import { TableActionsWrapper } from '@components'

import { Button, Flex, IconButton, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface DocumentsBulkActionsProps {
  onDownload?: () => void
  onMoveToFolder?: () => void
  onDelete?: () => void
}

export const DocumentsBulkActions = ({
  onDownload,
  onMoveToFolder,
  onDelete,
}: DocumentsBulkActionsProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <TableActionsWrapper>
      <Flex alignItems="center" gap={Spacing.S8}>
        {onDownload && <IconButton icon="download" variant="outlined" onClick={onDownload} />}
        {onMoveToFolder && <IconButton icon="folderInput" variant="outlined" onClick={onMoveToFolder} />}
        {onDelete && (
          <Button icon="trash" variant="outlined" color="danger" onClick={onDelete}>
            {t('delete')}
          </Button>
        )}
      </Flex>
    </TableActionsWrapper>
  )
}
